'use client'

import { useRouter } from '@/navigation'
import React, { forwardRef } from 'react'
import Badge from '../design-system/badge'
import IconButton, { IconButtonProps } from '../design-system/icon-button'
import Tooltip from '../design-system/tooltip'
import NotificationIcon from '../icons/notification'
import useNotificationsCount from './use-notifications-count'

const NotificationsTrigger = forwardRef(function NotificationsTrigger(
  props: IconButtonProps & { redirect?: boolean },
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const { onClick, redirect, ...other } = props

  const count = useNotificationsCount()

  const router = useRouter()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event)

      if (event.defaultPrevented) {
        return
      }
    }

    if (redirect) {
      router.push('/notifications')
    }
  }

  return (
    <Badge
      count={count.total < 100 ? count.total : '99+'}
      invisible={count.total === 0}
    >
      <Tooltip title='Notifications'>
        <IconButton
          ref={ref}
          aria-label='Notifications'
          onClick={handleClick}
          {...other}
        >
          <NotificationIcon />
        </IconButton>
      </Tooltip>
    </Badge>
  )
})

export default NotificationsTrigger
